export enum EnvironmentKeys {
  api = 'api',
  adminDomains = 'adminDomains',
  agGridLicense = 'agGridLicense',
  googleAnalyticsId = 'googleAnalyticsId',
  applicationInsightsKey = 'applicationInsightsKey',
  storage = 'storage',
  mailtoHelp = 'mailtoHelp',
  disableAnalytics = 'disableAnalytics',
  version = 'version',
  enableBuildNumberInUI = 'enableBuildNumberInUI',
  
  clientId = 'clientId',
  clientSecret = 'clientSecret',
  
  msalClientId = 'msalClientId',
  msalAuthority = 'msalAuthority',
  msalRedirectUri = 'msalRedirectUri',
  
  heapAnalyticsAppId = 'heapAnalyticsAppId',
  useHeapAnalytics = 'useHeapAnalytics',
  
  plannerDataSitePlanId = 'plannerDataSitePlanId',
  plannerMnpiDataSitePlanId = 'plannerMnpiDataSitePlanId',
  plannerDataSiteEmailBucketId = 'plannerDataSiteEmailBucketId',
  plannerDataSiteMissingEmailBucketId = 'plannerDataSiteMissingEmailBucketId',
  plannerMnpiDataSiteMissingEmailBucketId = 'plannerMnpiDataSiteMissingEmailBucketId',
  plannerDataSiteRogueBucketId = 'plannerDataSiteRogueBucketId',
  plannerCallTranscriptPendingBucketId = 'plannerCallTranscriptPendingBucketId',
  plannerCallTranscriptNeedsApprovalBucketId = 'plannerCallTranscriptNeedsApprovalBucketId',
  plannerMnpiDataSiteEmailBucketId = 'plannerMnpiDataSiteEmailBucketId',
  plannerMnpiDataSiteRogueBucketId = 'plannerMnpiDataSiteRogueBucketId',
  plannerMnpiCallTranscriptPendingBucketId = 'plannerMnpiCallTranscriptPendingBucketId',
  plannerMnpiCallTranscriptNeedsApprovalBucketId = 'plannerMnpiCallTranscriptNeedsApprovalBucketId',
  plannerDataSiteGroupId = 'plannerDataSiteGroupId',
  plannerMnpiDataSiteGroupId = 'plannerMnpiDataSiteGroupId',
  plannerTaskUrl = 'plannerTaskUrl',
  
  isStandAloneMode = 'isStandAloneMode',
  shouldLogLocal = 'shouldLogLocal',
  cscpUri = 'cscpUri',
  cscpIframePathPrefix = 'cscpIframePathPrefix',
  cscpWindowPathPrefix = 'cscpWindowPathPrefix',
  
  releaseFeatureFlagPublicCompanies = 'releaseFeatureFlagPublicCompanies',
  releaseFeatureFlagClos = 'releaseFeatureFlagClos',
  releaseFeatureFlagDocumentHosting = 'releaseFeatureFlagDocumentHosting',
  releaseFeatureFlagCompanyHistory = 'releaseFeatureFlagCompanyHistory',
  releaseFeatureFlagBixbyCompliance = 'releaseFeatureFlagBixbyCompliance',
  releaseFeatureFlagCreditSightsCovenantReview = 'releaseFeatureFlagCreditSightsCovenantReview',
  releaseFeatureFlagCompanyComps = 'releaseFeatureFlagCompanyComps',
  releaseFeatureFlagCreditSightsNewsIntegration = 'releaseFeatureFlagCreditSightsNewsIntegration',
  releaseFeatureFlagCreditSightsTranscriptionsIntegration = 'releaseFeatureFlagCreditSightsTranscriptionsIntegration',
  releaseFeatureFlagHistoricalFinancialModels = 'releaseFeatureFlagHistoricalFinancialModels',
  releaseFeatureFlagSFDR = 'releaseFeatureFlagSFDR',
  releaseFeatureFlagTreppCLO = 'releaseFeatureFlagTreppCLO',
  releaseFeatureFlagCloPermissioning = 'releaseFeatureFlagCloPermissioning',
  releaseFeatureFlagClientProvidedDataSites = 'releaseFeatureFlagClientProvidedDataSites',
  
  privacyPolicyUrl = 'privacyPolicyUrl',
  termsOfServiceUrl = 'termsOfServiceUrl',
  creditSightsUrl = 'creditSightsUrl',
  cutoverLimit = 'cutoverLimit',
}
